module.exports = __webpack_public_path__ + "img/icons B_26.251f4193.svg";